import { gql } from "graphql-tag";

import { documentLink, externalLink } from "~/app/prismic/prismic-fragments";

export const getShopByOffer = pageType => gql`
  fragment ${pageType}_Shop_by_offer on ${pageType}BodyShop_by_offer {
    type
    label
    primary {
      heading
      list_type
    }
    fields {
      image
      sub_title
      link {
        ... externalLink
        ... on Collection_page {
          _meta {
            uid
            type
          }
          body {
            __typename
          }
        }
        ... documentLink
      }
    }
}
${documentLink}
${externalLink}`;
